import { Grid } from "@mui/material";
import Details from "./component/Details";

const TabSubstitution = () => {

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid item container xs={12} sm={12} md={12} spacing={2}>
                <Grid item xs={12}>
                    <Details />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default TabSubstitution;
